import { ProductConfigKeys, useJurisdictionStore } from '@/hooks/use-jurisdiction';

import { parseTakerFeeTheta } from '../utils/prediction-position';

export const usePredictionTakerFeeTheta = () =>
    useJurisdictionStore(state =>
        parseTakerFeeTheta(
            state.jurisdictionSettings?.productConfig?.keyValuePairs?.[ProductConfigKeys.PredictionsConfig]
                ?.taker_fee_theta
        )
    );
